import React from 'react'
import { IAuditEventData, SupportUserAuditSnapshotV1 } from 'api'
import { Box } from 'cs-kevlar-react'
import { DetailArrayField } from './DetailArrayField'
import { DetailField } from './DetailField'
import { UnavailableDetails } from './UnavailableDetails'
import { useDetailStyles } from './useDetailStyles'
import { resolveSnapshots } from './utils'

interface SupportUserDetailsProps {
  eventData: IAuditEventData
}

export const SupportUserDetails: React.FunctionComponent<SupportUserDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const [originalSnapshot, updatedSnapshot] = resolveSnapshots<
    SupportUserAuditSnapshotV1
  >(eventData, nameof<SupportUserAuditSnapshotV1>())
  const showDiff = !!originalSnapshot && !!updatedSnapshot

  if (!updatedSnapshot && !originalSnapshot) return <UnavailableDetails />

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailField
          label="Name"
          showDiff={showDiff}
          original={originalSnapshot?.username}
          updated={updatedSnapshot?.username}
        />

        <DetailField
          label="Disabled"
          showDiff={showDiff}
          original={originalSnapshot?.isDisabled?.toString()}
          updated={updatedSnapshot?.isDisabled?.toString()}
        />

        <DetailArrayField
          label="Permissions"
          showDiff={showDiff}
          original={originalSnapshot?.permissions}
          updated={updatedSnapshot?.permissions}
        />
      </Box>
    </React.Fragment>
  )
}
